import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { PlanoAcaoSituacao } from "../models/plano-acao-situacao.model";

@Injectable()
export class PontoCriticoAcaoSituacaoService extends BaseService<PlanoAcaoSituacao>{

  constructor(public http: HttpClient) {
    super(http);
  }

  public getInitValues(idAcao: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/init-values/' + idAcao, { headers: this.headers });
  }

  public getEntregaInitValues(idAcao: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/entrega/init-values/' + idAcao, { headers: this.headers });
  }

  public getIndicadorInitValues(idAcao: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/indicador/init-values/' + idAcao, { headers: this.headers });
  }

  public getAgregadorIndicadorInitValues(idAcao: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/agregador-indicador/init-values/' + idAcao, { headers: this.headers });
  }

  public getByIdStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/list-status', { headers: this.headers });
  }

  public getByIdEntregaStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/entrega-list-status', { headers: this.headers });
  }

  public getByIdIndicadorStatus(): Observable<any> {
    return this.http.get<any>(this.baseUrl + '/indicador-list-status', { headers: this.headers });
  }

  public getByIdEntrega(id: number): Observable<PlanoAcaoSituacao> {
    return this.http.get<PlanoAcaoSituacao>(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public getByIdIndicador(id: number): Observable<PlanoAcaoSituacao> {
    return this.http.get<PlanoAcaoSituacao>(this.baseUrl + '/indicador/' + id, { headers: this.headers });
  }

  public getByIdAgregadorIndicador(id: number): Observable<PlanoAcaoSituacao> {
    return this.http.get<PlanoAcaoSituacao>(this.baseUrl + '/agregador-indicador/' + id, { headers: this.headers });
  }

  public entregaCreate(obj: PlanoAcaoSituacao): Observable<PlanoAcaoSituacao> {
    return this.http.post<PlanoAcaoSituacao>(this.baseUrl + '/entrega', obj, { headers: this.headers });
  }

  public indicadorCreate(obj: PlanoAcaoSituacao): Observable<PlanoAcaoSituacao> {
    return this.http.post<PlanoAcaoSituacao>(this.baseUrl + '/indicador', obj, { headers: this.headers });
  }

  public agregadorIndicadorCreate(obj: PlanoAcaoSituacao): Observable<PlanoAcaoSituacao> {
    return this.http.post<PlanoAcaoSituacao>(this.baseUrl + '/agregador-indicador', obj, { headers: this.headers });
  }

  public entregaUpdate(obj: PlanoAcaoSituacao, id: number): Observable<PlanoAcaoSituacao> {
    return this.http.put<PlanoAcaoSituacao>(this.baseUrl + '/entrega/' + id, obj, { headers: this.headers });
  }

  public indicadorUpdate(obj: PlanoAcaoSituacao, id: number): Observable<PlanoAcaoSituacao> {
    return this.http.put<PlanoAcaoSituacao>(this.baseUrl + '/indicador/' + id, obj, { headers: this.headers });
  }

  public agregadorIndicadorUpdate(obj: PlanoAcaoSituacao, id: number): Observable<PlanoAcaoSituacao> {
    return this.http.put<PlanoAcaoSituacao>(this.baseUrl + '/agregador-indicador/' + id, obj, { headers: this.headers });
  }

  public entregaDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/entrega/' + id, { headers: this.headers });
  }

  public indicadorDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/indicador/' + id, { headers: this.headers });
  }

  public agregadorIndicadorDelete(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + '/agregador-indicador/' + id, { headers: this.headers });
  }

  public getPathModule(): string {
    return '/projetos/ponto-critico-acao-situacao';
  }

}